import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    standard: () => ({
      '& .MuiOutlinedInput-root': {
        height: 56,
      },

      // Center the label which is not shrunk
      '.MuiFormLabel-root:not(.MuiInputLabel-shrink)': {
        top: '-7px',
      },
    }),
  },
};
